$(() => {
  const isCourseGuide = function (data) {
    return data.type_label === 'Course Guide';
  };

  const isSubjectGuide = function (data) {
    return data.type_label === 'Subject Guide';
  };

  const isOtherGuide = function (data) {
    return data.type_label !== 'Course Guide' && data.type_label !== 'Subject Guide';
  };

  const buildStandardList = function (guides, title = 'Guides') {
    const heading = `<h2>${title}</h2>`;
    let str = `${heading}<ul>`;

    guides.forEach((guide) => {
      let path = guide.redirect_url || guide.friendly_url || guide.url;
      path += `${path.match(/[?]/g) ? '&' : '?'}utm_source=www&utm_medium=staff_profile`;
      str += `<li><a class="d-block" href="${path}">${guide.name}</a></li>`;
    });
    str += '</ul>';
    $('#libguides').append(str);
  };

  const groupBy = function (data, key) {
    return data.reduce((storage, item) => {
      const newStorage = storage;
      const group = item[key];
      newStorage[group] = storage[group] || [];
      newStorage[group].push(item);
      return newStorage;
    }, {});
  };

  function buildCourseList(guides, title = 'Guides') {
    const sectionGuides = [];
    guides.forEach((guide) => {
      const newGuide = guide;
      const { name } = guide;
      newGuide.section = name.substr(0, name.indexOf(' '))
        .replace(/[^A-Za-z0-9\s]/g, '')
        .toUpperCase();
      sectionGuides.push(newGuide);
    });

    const groupedGuides = groupBy(sectionGuides, 'section');
    const heading = `<h2>${title}</h2>`;
    let str = `${heading}<div class="btn-group d-flex flex-wrap">`;

    Object.values(groupedGuides).forEach(([value]) => {
      str += `<a class="btn btn-link" href="#${value.section.toLowerCase()}">${value.section}</a>`;
    });
    str += '</div>';

    Object.values(groupedGuides).forEach(([value]) => {
      const hr = `<div class="border-left border-secondary pl-3 mb-2"><h3 id="${value.section.toLowerCase()}" class="mt-4 mb-3 h5">${value.section}</h3>`;

      str += `${hr}<ul>`;

      groupedGuides[value.section].forEach((guide) => {
        let path = guide.redirect_url || guide.friendly_url || guide.url;
        path += `${path.match(/[?]/g) ? '&' : '?'}utm_source=www&utm_medium=staff_profile`;
        str += `<li class="mb-2"><a class="d-block" href="${path}">${guide.name}</a></li>`;
      });
      str += '</ul></div>';
    });

    $('#libguides').append(str);
  }

  $.getJSON(window.untLibVars.springShareURL, (data) => {
    if (data.length !== 0) {
      const subjectGuides = data.filter(isSubjectGuide);
      const courseGuides = data.filter(isCourseGuide);
      const otherGuides = data.filter(isOtherGuide);

      if (subjectGuides.length !== 0) {
        buildStandardList(subjectGuides, 'Subject Guides');
      }
      if (courseGuides.length !== 0) {
        buildCourseList(courseGuides, 'Course Guides');
      }
      if (otherGuides.length !== 0) {
        buildStandardList(otherGuides, 'Topic &amp; General Purpose Guides');
      }
    }
  });
});
